"use client";
import { typographyClasses } from "@mui/material/Typography";
import { createTheme } from "@mui/material/styles";
import { themeBreakpoints } from "./themeBreakpoints.module";
import { resolve, stripUnitFromObject, tokenBreakpoints } from "./utils";
const defaultTheme = createTheme();
export const breakpointsUp = defaultTheme.breakpoints.up;
export const fontFamily = (val, fontFamilyFallback) => {
    const fallbackFont = fontFamilyFallback || "sans-serif"; // Setting sensible default
    return `${val}, ${fallbackFont}`;
};
export const typography = (variant, fontFamilyFallback) => {
    const style = {};
    if (!variant) {
        return style;
    }
    if ("fontFamily" in variant) {
        style.fontFamily = fontFamily(variant.fontFamily, fontFamilyFallback);
    }
    if ("fontWeight" in variant) {
        style.fontWeight = variant.fontWeight;
    }
    if ("lineHeight" in variant) {
        style.lineHeight = variant.lineHeight;
    }
    if ("fontSize" in variant) {
        style.fontSize = variant.fontSize;
    }
    if ("letterSpacing" in variant) {
        style.letterSpacing = variant.letterSpacing;
    }
    if ("textDecoration" in variant) {
        style.textDecoration = variant.textDecoration;
    }
    if ("textCase" in variant) {
        style.textTransform = variant.textCase;
    }
    if ("paragraphSpacing" in variant) {
        style[`&.${typographyClasses.gutterBottom}`] = {
            marginBottom: variant.paragraphSpacing,
        };
    }
    style["b, strong"] = {
        fontWeight: "bolder",
    };
    return style;
};
export const typographyResponsive = (designTokensRoot, typographyVariant, additional = {}, altPath) => {
    const dt = designTokensRoot;
    const typePath = altPath || dt.typography;
    const breakpoints = stripUnitFromObject(dt.layout.media);
    const fontFamilyFallbackType = fontType(typographyVariant);
    const arTypographyVariant = typographyVariant.split(".");
    let style = {};
    if (typePath.default) {
        style = typography(resolve(typePath.default, arTypographyVariant), dt.fontFamilies[fontFamilyFallbackType].fallback);
        if (additional) {
            style = Object.assign(Object.assign({}, style), additional);
        }
    }
    for (const i in themeBreakpoints(breakpoints).keys) {
        if (typePath.media[tokenBreakpoints[i]]) {
            const breakpoint = breakpointsUp(themeBreakpoints(breakpoints).values[themeBreakpoints(breakpoints).keys[i]]);
            const tp = typography(resolve(typePath.media[tokenBreakpoints[i]], arTypographyVariant), dt.fontFamilies[fontFamilyFallbackType].fallback);
            if (Object.keys(tp).length > 0) {
                style[breakpoint] = Object.assign(Object.assign({}, tp), additional);
            }
        }
    }
    return style;
};
const fontType = (variant) => {
    if (typeof variant === "object") {
        return "body";
    }
    const rxHeadings = /H\d{1,2}|subtitle\d/i;
    const rxDisplay = /display\d{1,2}/i;
    if (rxHeadings.test(variant)) {
        return "heading";
    }
    if (rxDisplay.test(variant)) {
        return "display";
    }
    return "body";
};
